<a href="#maincontent" class="skip-link">{{skipToMainContentLabel}}</a>
<soho-icons *ngIf="!inUpliftTheme"></soho-icons>
<soho-icons-uplift *ngIf="inUpliftTheme"></soho-icons-uplift>
<soho-icons-empty *ngIf="!inUpliftTheme"></soho-icons-empty>
<soho-icons-empty-new *ngIf="inUpliftTheme"></soho-icons-empty-new>

<ng-container *ngIf="menuIsV2">
  <nav soho-application-menu #SohoApplicationMenu
       *ngIf="!hideAppMenu && isXiHarness"
       data-automation-id="lm-appmenu-application-menu"
       breakpoint="desktop"
       [isPersonalizable]=applyColorToMenu
       class="has-searchfield"
       [filterable]=false
       [dismissOnClickMobile]=true
       (menuVisibility)="onMenuVisibility($event)"
       (accordionExpand)="onAccordionExpand($event)"
       [openOnLarge]="openOnLarge"
       [style.height]="'100%'"
  >
    <lm-application-menu
            *ngIf="isXiHarness"
            class="application-menu-wrapper"
            [asOfDate]="asOfDate"
            [showDeletedRecords]="showDeletedRecords"
            [applyColorToMenu]="applyColorToMenu"
            [visibility]="menuSearchMode ? 'hidden' : 'visible'"
            (webAppMenuLoaded)="onWebAppMenuLoaded($event)"
            (menuLoaded)="onMenuLoaded($event)"
            (menuSearched)="onMenuSearched($event)"
            (asOfDateChanged)="onAsOfDateChanged($event)"
            (asOfDateClearedEvent)="onAsOfDateCleared()"
            (roleSelected)="roleSelected()"
    ></lm-application-menu>
  </nav>

  <nav soho-application-menu *ngIf="menuSearchMode"
       id="application-menu-search"
       data-automation-id="lm-appmenu-application-search-menu"
       #SohoApplicationMenuSearch
       breakpoint="desktop"
       class="has-searchfield"
       [filterable]=false
       [isPersonalizable]=applyColorToMenu
       [dismissOnClickMobile]=true
  >
    <lm-application-menu-search
      [searchString]="searchString"
      [menuSpecsByWebApp]="menuSpecsByWebApp"
      [menuSearchResultsByWebApp]="menuSearchResultsByWebApp"
      [dataSearchResults]="dataSearchResults"
      [reportSearchResults]="reportSearchResults"
      (menuSearched)="onMenuSearched($event)"
      (menuSearchCleared)="onMenuSearchCleared()"
    ></lm-application-menu-search>
  </nav>
</ng-container>

<ng-container *ngIf="menuIsV1">
  <nav soho-application-menu #SohoApplicationMenu
       *ngIf="!hideAppMenu && isXiHarness"
       breakpoint="desktop"
       [isPersonalizable]=applyColorToMenu
       class="has-searchfield"
       [filterable]=false
       [dismissOnClickMobile]=true
       (menuVisibility)="onMenuVisibility($event)"
       (accordionExpand)="onAccordionExpand($event)"
       [openOnLarge]="openOnLarge"
       [style.height]="'100%'"
  >
    <lm-banner-nav *ngIf="isXiHarness"
                   class="application-menu-wrapper"
                   [asOfDate]="asOfDate"
                   [applyColorToMenu]="applyColorToMenu"
                   [visibility]="menuSearchMode ? 'hidden' : 'visible'"
                   (webAppMenuLoaded)="onWebAppMenuLoaded($event)"
                   (menuLoaded)="onMenuLoaded($event)"
                   (menuSearched)="onMenuSearched($event)"
                   (asOfDateChanged)="onAsOfDateChanged($event)"
                   (asOfDateClearedEvent)="onAsOfDateCleared()"
                   (onRoleSelected)="roleSelected()">
    </lm-banner-nav>
  </nav>
  <nav soho-application-menu
       *ngIf="menuSearchMode"
       id="banner-search"
       #SohoApplicationMenuSearch
       breakpoint="desktop"
       class="has-searchfield"
       [filterable]=false
       [isPersonalizable]=applyColorToMenu
       [dismissOnClickMobile]=true
       (menuVisibility)="onSearchMenuVisibility()"
  >
    <lm-banner-search
      [searchString]="searchString"
      [menuSpecsByWebApp]="menuSpecsByWebApp"
      [menuSearchResultsByWebApp]="menuSearchResultsByWebApp"
      [dataSearchResults]="dataSearchResults"
      [reportSearchResults]="reportSearchResults"
      (menuSearched)="onMenuSearched($event)"
      (menuSearchCleared)="onMenuSearchCleared()"
    ></lm-banner-search>
  </nav>
</ng-container>


<!--
  - margin-top - of 60px in maincontent is causing issues when showing th busy indicator. It's causing
    shifting when displaying a formComponent (specifically JobPosting.PostingDisplay). Hard coding to 0px.

  - text - Set to a literal 1 space char so that the default text of the busy indicator won't display.
  - displayDelay - default and minimum is 20 ms.
  - blockUI - set to true to stop input while the busy indicator is active
  - timeToComplete - the maximum amount of time the indicator is up. useful for when the busyindicator.close doesn't
                     get messaged due to an error or something.
  - transparentOverlay - whether or not to display a fully transparent overlay instead of the standard grey semi-transparent overlay.
  - complete - event that is fired when the timeToComplete is done; fires regardless if busyIndicator is programmatically stopped
  -->
<div soho-busyindicator
     #fullmaincontent
     id="fullmaincontent"
     [ngClass]="{'page-container': true, 'scrollable': useFullPageScrolling,  'lm-hide-titlebar': hideTitle, 'viewMoreNav' : showViewMoreNav}"
     [text]="' '"
     [blockUI]="true"
     [displayDelay]="0"
     [transparentOverlay]="true"
     [style.margin-top]="'0px'"
     [timeToComplete]="this.uiLoadingIndicatorTimeout"
     (complete)="onBusyComplete($event)"
>
  <ng-container *ngIf="!inMingleWidget && !inMingleInbox && !hideTitle && !bannerInRoute">
    <lm-banner-header
            role="banner"
            [class.lm-sticky-banner]="true"
            (appMenuTriggerEvent)="onAppMenuTriggerEvent($event)"
            (hasHeaderTabs)="onHasHeaderTabs($event)"
            (asOfDateChanged)="onAsOfDateChanged($event)"
            (asOfDateCleared)="onAsOfDateCleared()"
            (useFullPageScrolling)="fullPageScrolling($event)"
            [asOfDate]="asOfDate"></lm-banner-header>
  </ng-container>


  <!--  [style.position]="'relative'"-->
  <!--  [style.height]="'calc(100% - 100px)'"-->
  <!--  !inMingleWidget && !inMingleInbox && !hideTitle ? 'calc(100% - 60px)' : -->



  <div #maincontent *ngIf="webAppsLoaded"
       id="maincontent"
       [ngStyle]="{'height': onMobile ? 'calc(100% - 50px)' : !inMingleWidget && !inMingleInbox && !hideTitle && !bannerInRoute ? hasHeaderTabs ? 'calc(100% - 100px)' : 'calc(100% - 61px)' : '100%' }">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
  </div>

</div>
<!-- MINGLE VIEW MORE -->
<lm-view-more *ngIf="showViewMoreNav"></lm-view-more>

<div #dialogPlaceholder id="lmAppComponentDialogPlaceholder" class="lmDialogPlaceholder"></div>
<div id="lm-page-overlay" class="personalize-overlay" style="z-index: -1;"></div>
